const validate = (values) => {
  const attrs = values || {};
  const errors = {};
  if (!attrs.materia || !attrs.materia.value) {
    errors.materia = 'Debe seleccionar una materia';
  }

  if (!attrs.interventor || !attrs.interventor.value) {
    errors.interventor = 'Debe seleccionar un interventor';
  }

  if (attrs.interventorAuxiliar && attrs.interventorAuxiliar.value === attrs.interventor.value) {
    // errors.interventor = 'Ya seleccionó a este funcionario este como el interventor principal'
  }

  if (!attrs.fecha) {
    errors.fecha = 'Debe ingresar la fecha del examen';
  }

  if (!attrs.fechaLimiteInscripcion) {
    errors.fechaLimiteInscripcion = 'Debe ingresar la fecha límite inscripción';
  }

  if (attrs.estado && attrs.estado.value === 4) {
    if (!attrs.fechaAtencionReclamos) {
      errors.fechaAtencionReclamos = 'Debe ingresar la fecha de atendimiento de los reclamos';
    }
    if (!attrs.fechaInicioReclamo) {
      errors.fechaInicioReclamo = 'Debe ingresar la fecha de inicio del reclamo';
    }
    if (!attrs.fechaFinReclamo) {
      errors.fechaFinReclamo = 'Debe ingresar la fecha de fin del reclamo';
    }
    if (attrs.fechaInicioReclamo && attrs.fechaFinReclamo) {
      const start = new Date(attrs.fechaInicioReclamo);
      const end = new Date(attrs.fechaFinReclamo);
      if (start > end) {
        errors.fechaInicioReclamo = 'La fecha de inicio de reclamos no puede ser posterior a la fecha de fin';
        errors.fechaFinReclamo = 'La fecha de fin de reclamos no puede ser anterior a la fecha de inicio';
      }
    }
  }

  if (!attrs.periodo || !attrs.periodo.value) {
    errors.periodo = 'Debe ingresar el periodo';
  }

  if (!attrs.nroActa) {
    errors.nroActa = 'Debe ingresar el número de acta';
  }

  return errors;
};

export default validate;
